import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { apiRequest } from "../utils/api";
import FormFeedback from "./Common/FormFeedback";
import "./StaticPages.css";

export default function EmailVerified() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const type = searchParams.get("type");
  const initialEmail = searchParams.get("email") || "";
  const [email, setEmail] = useState(initialEmail);
  const [isLoading, setIsLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [resendError, setResendError] = useState(false);
  const successMessages = {
    "candidate-profile": "Your email has been verified. Your resume/CV information can now be published on Epic Jobs.",
    job: "Your email has been verified. Your job posting is now waiting for admin approval.",
    "job-application": "Your email has been verified. Your job application is now shared with the employer on Epic Jobs.",
    account: "Your email address has been verified. You can now login.",
  };
  const success = status === "success" ? (successMessages[type] || successMessages.account) : false;
  const canResendAccountVerification = !type && (status === "expired" || status === "invalid");
  const error = status === "expired"
    ? "This verification link has expired. Send yourself a fresh verification email."
    : status === "invalid"
      ? "This verification link is invalid or has expired."
      : false;
  const isSuccess = Boolean(success);
  const pageTitle = isSuccess ? "Email Verified" : "Verification Needed";
  const pageText = isSuccess
    ? "Your Epic Jobs account is ready. Continue to login and pick up where you left off."
    : "We could not confirm this verification link. You can request a fresh email and try again.";
  const iconClass = isSuccess ? "success" : "danger";
  const iconName = isSuccess ? "la-check" : "la-exclamation-circle";

  function resendVerification(e) {
    e.preventDefault();

    if (!email) {
      setResendError("Please enter the email address used during signup.");
      setResendSuccess(false);
      return;
    }

    setIsLoading(true);
    setResendError(false);
    setResendSuccess(false);

    const formData = new FormData();
    formData.append("email", email);

    apiRequest("/email/verification-notification", {
      method: "POST",
      body: formData,
    })
      .then((data) => {
        setIsLoading(false);
        setResendSuccess(data.message);
      })
      .catch((error) => {
        setIsLoading(false);
        setResendError(error.message);
      });
  }

  return (
    <section className="static-page-section verification-page-section">
      <div className="auto-container">
        <div className="static-hero verification-hero">
          <span className={`icon ${iconClass}`}><i className={`la ${iconName}`}></i></span>
          <h1>{pageTitle}</h1>
          <p>{pageText}</p>
          <div className="static-actions">
            <Link to="/login" className="theme-btn btn-style-one">Go to Login</Link>
            <Link to="/jobs" className="theme-btn btn-style-three">Browse Jobs</Link>
          </div>
        </div>

        <div className="verification-panel">
          <div className="verification-panel-content">
            <span className="verification-eyebrow">Account Verification</span>
            <h2>{isSuccess ? "You're all set" : "Link needs attention"}</h2>
            <FormFeedback success={success} error={error || "Email verification status could not be confirmed."} />
            <FormFeedback success={resendSuccess} error={resendError} />

            {canResendAccountVerification && (
              <form onSubmit={resendVerification} className="verification-resend-form">
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your signup email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <button className="theme-btn btn-style-one" type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Resend verification email"}
                </button>
              </form>
            )}
          </div>
          <div className="verification-side">
            <div>
              <span>Next Step</span>
              <strong>{isSuccess ? "Login to your dashboard" : "Request a fresh link"}</strong>
            </div>
            <div>
              <span>Need Help?</span>
              <strong><Link to="/contact">Contact support</Link></strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
